import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import multiguard from "vue-router-multiguard";

import Home from "../views/Home.vue";

import Companies from "../views/Companies.vue";
import Request from "../views/Request.vue";

// auth
import Login from "../views/Login.vue";
import Register from "../views/Register.vue";

// admin area
import AdminCompanies from "../views/admin/AdminCompanies.vue";
import AdminDisabledCompanies from "../views/admin/AdminDisabledCompanies.vue";
import Edit from "../views/admin/EditCompany.vue";
import AdminAd from "../views/admin/AdminAd.vue";
import AdminAddAd from "../views/admin/AdminAddAd.vue";

import {
  requireAdminAuth,
  // requireAuth,
  loginedUser
} from "../AuthGuard";

Vue.use(VueRouter);

// clear error state
const clearStates = (to, from, next) => {
  store.commit("clearMessageState");
  next();
};

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "صفحه اصلی"
    },
    beforeEnter: clearStates
  },
  {
    path: "/Login",
    name: "Login",
    component: Login,
    meta: {
      title: "ورود",
      layout: "none"
    },
    beforeEnter: multiguard([clearStates, loginedUser])
  },
  {
    path: "/Register",
    name: "Register",
    component: Register,
    meta: {
      title: "ثبت نام",
      layout: "none"
    },
    beforeEnter: multiguard([clearStates, loginedUser])
  },
  {
    path: "/request",
    name: "Request",
    component: Request,
    meta: {
      title: "درخواست ثبت",
      layout: "none"
    },
    beforeEnter: clearStates
  },
  {
    path: "/companies/:id",
    name: "Companies",
    component: Companies,
    meta: {
      title: "لیست شرکت ها"
    },
    beforeEnter: clearStates
  },
  {
    path: "/admin",
    name: "AdminCompanies",
    component: AdminCompanies,
    meta: {
      title: "لیست شرکت ها",
      layout: "admin"
    },
    beforeEnter: multiguard([clearStates, requireAdminAuth])
  },
  {
    path: "/admin/disabled",
    name: "AdminDisabledCompanies",
    component: AdminDisabledCompanies,
    meta: {
      title: "لیست شرکت های غیرفعال",
      layout: "admin"
    },
    beforeEnter: multiguard([clearStates, requireAdminAuth])
  },
  {
    path: "/edit/:id",
    name: "Edit",
    component: Edit,
    meta: {
      title: "ویرایش شرکت",
      layout: "admin"
    },
    beforeEnter: multiguard([clearStates, requireAdminAuth])
  },
  {
    path: "/admin/ad",
    name: "AdminAd",
    component: AdminAd,
    meta: {
      title: "لیست تبلیغات",
      layout: "admin"
    },
    beforeEnter: multiguard([clearStates, requireAdminAuth])
  },
  {
    path: "/admin/ad/add",
    name: "AdminAddAd",
    component: AdminAddAd,
    meta: {
      title: "ایجاد تبلیغ",
      layout: "admin"
    },
    beforeEnter: multiguard([clearStates, requireAdminAuth])
  }
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;
